import axios from "axios";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export const listarStickers = (params) =>
  axios.get(`${API}/calib-stickers`, { ...auth(), params }).then((r) => r.data);

export const obtenerConfigStickers = () =>
  axios.get(`${API}/calib-stickers/config`, auth()).then((r) => r.data);

export const guardarConfigStickers = (config) =>
  axios.put(`${API}/calib-stickers/config`, config, auth()).then((r) => r.data);

// Vista previa local del número (misma regla que el servidor)
export const previsualizarNumero = ({ prefijo = "", sufijo = "", digitos, siguiente }) => {
  const hoy = new Date();
  const anio = String(hoy.getFullYear());
  const tokens = {
    AAAA: anio,
    AA: anio.slice(-2),
    MM: String(hoy.getMonth() + 1).padStart(2, "0"),
  };
  const conFecha = (txt) => txt.replace(/\{(AAAA|AA|MM)\}/g, (_, t) => tokens[t]);
  const n = Math.max(1, parseInt(siguiente, 10) || 1);
  const d = Math.min(10, Math.max(1, parseInt(digitos, 10) || 1));
  return `${conFecha(prefijo)}${String(n).padStart(d, "0")}${conFecha(sufijo)}`;
};

export const generarStickers = (cantidad) =>
  axios
    .post(`${API}/calib-stickers/generar`, { cantidad }, auth())
    .then((r) => r.data);

export const stickerDeCronograma = (cronogramaId) =>
  axios
    .get(`${API}/calib-stickers/cronograma/${cronogramaId}`, auth())
    .then((r) => r.data);

export const asignarSticker = (cronogramaId, stickerId = null) =>
  axios
    .post(
      `${API}/calib-stickers/asignar`,
      { cronogramaId, stickerId },
      auth(),
    )
    .then((r) => r.data);

export const stickersPorCronogramas = (ids) =>
  axios
    .post(`${API}/calib-stickers/por-cronogramas`, { ids }, auth())
    .then((r) => r.data);

export const anularSticker = (id) =>
  axios.post(`${API}/calib-stickers/${id}/anular`, {}, auth()).then((r) => r.data);

export const urlCertificadoPublico = (token) =>
  `${window.location.origin}/certificado/${token}`;

/**
 * Abre un PDF protegido en una pestaña nueva. La pestaña se abre antes de la
 * petición para que el navegador no la bloquee como ventana emergente.
 */
export const abrirPestana = () => window.open("", "_blank");

const abrirPdf = async (path, params, win = abrirPestana()) => {
  if (!win) {
    toast.error("Habilita las ventanas emergentes para ver los stickers");
    return;
  }
  try {
    const res = await axios.get(`${API}${path}`, {
      ...auth(),
      params,
      responseType: "blob",
    });
    win.location.href = window.URL.createObjectURL(
      new Blob([res.data], { type: "application/pdf" }),
    );
  } catch (err) {
    console.error("Error abriendo PDF de stickers:", err);
    win.close();
    toast.error("No se pudo generar el PDF de stickers");
  }
};

// fecha: undefined → la registrada (o en blanco); "sin" → en blanco; "AAAA-MM-DD" → esa fecha
export const imprimirStickers = ({ ids, lote, formato = "rollo", fecha }, win) =>
  abrirPdf(
    "/calib-stickers/pdf",
    {
      formato,
      ...(fecha ? { fecha } : {}),
      ...(lote ? { lote } : { ids: (ids || []).join(",") }),
    },
    win,
  );

export const imprimirSticker = (id, formato = "rollo") =>
  abrirPdf(`/calib-stickers/${id}/pdf`, { formato });
